var _rect, _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCashButtonImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 140,
    viewBox: "0 0 145 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 145,
    height: 140,
    fill: "url(#paint0_linear_5245_69953)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87 22H56V53H87V22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 22C37.9487 23.1793 25.1415 36.411 24 53H54V22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 55H24V86H54V55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 55H89V86H120V55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 118C105.592 116.864 118.82 104.057 120 88H89V118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 88H56V118H87V88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 88H24C25.136 104.062 37.9377 116.864 54 118V88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94 15V47H126C125.995 29.327 111.668 15 94 15Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3609 70.2C36.3609 76.052 40.6449 80.168 46.2729 80.168C50.6129 80.168 54.1409 77.872 55.4569 73.84H50.9489C50.0249 75.744 48.3449 76.668 46.2449 76.668C42.8289 76.668 40.3929 74.148 40.3929 70.2C40.3929 66.224 42.8289 63.732 46.2449 63.732C48.3449 63.732 50.0249 64.656 50.9489 66.532H55.4569C54.1409 62.528 50.6129 60.204 46.2729 60.204C40.6449 60.204 36.3609 64.348 36.3609 70.2ZM57.797 72.188C57.797 77.032 60.933 80.252 64.853 80.252C67.317 80.252 69.081 79.076 70.005 77.732V80H73.953V64.488H70.005V66.7C69.081 65.412 67.373 64.236 64.881 64.236C60.933 64.236 57.797 67.344 57.797 72.188ZM70.005 72.244C70.005 75.184 68.045 76.808 65.889 76.808C63.789 76.808 61.801 75.128 61.801 72.188C61.801 69.248 63.789 67.68 65.889 67.68C68.045 67.68 70.005 69.304 70.005 72.244ZM89.8216 75.576C89.7096 69.892 81.1136 71.656 81.1136 68.828C81.1136 67.932 81.8696 67.344 83.3256 67.344C84.8656 67.344 85.8176 68.156 85.9296 69.36H89.6816C89.4576 66.28 87.1896 64.236 83.4376 64.236C79.6016 64.236 77.3056 66.308 77.3056 68.884C77.3056 74.568 86.0696 72.804 86.0696 75.576C86.0696 76.472 85.2296 77.172 83.6896 77.172C82.1216 77.172 81.0296 76.276 80.8896 75.1H76.9416C77.1096 77.984 79.8256 80.252 83.7176 80.252C87.4976 80.252 89.8216 78.236 89.8216 75.576ZM93.0394 80H96.9594V71.432C96.9594 68.94 98.3314 67.596 100.459 67.596C102.531 67.596 103.903 68.94 103.903 71.432V80H107.823V70.9C107.823 66.616 105.275 64.264 101.775 64.264C99.7034 64.264 97.9674 65.104 96.9594 66.42V59.28H93.0394V80Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5245_69953",
    x1: 72.5,
    y1: 0,
    x2: 72.5,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2797E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075C9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashButtonImage);
export default __webpack_public_path__ + "static/media/CashButtonImage.9e4732d4e42d704ccf1cef2f8386dd38.svg";
export { ForwardRef as ReactComponent };